module.exports = __webpack_public_path__ + "img/photo_2022-08-11_14-51-50.8ccb49b6.jpg";